import { ResourcesCache } from "@manager/loader/scenarioLoader/ResourcesCache";
import { inject, injectable } from "inversify";
import { ScenarioPath } from "../../../model/scenarioPath/ScenarioPath";
import { TYPES } from "../../di/types";
import { AnimationLayer } from "../../layer/AnimationLayer";
import { AnimationLayerObserver } from "../../layerObserver/AnimationLayerObserver";

export interface IndependentAnimationLayerManager {
  newScenarioElement(scenarioPath: ScenarioPath): void;
  resourcesLoaded(resourcesCache: ResourcesCache): void;
  getCurrentTime(): number;
  getTotalTime(): number;
  loadAnimation(): void;
  getIsPlaying(): boolean;
  play(): void;
  pause(): void;
  moveTo(time: number): void;
  registerObserver(observer: AnimationLayerObserver): void;
}

@injectable()
export class IndependentAnimationLayerManagerImpl implements IndependentAnimationLayerManager {
  private isPlaying: boolean = false;
  private animationJSON: any;
  private animationSrc: string;

  constructor(@inject(TYPES.layer.AnimationLayer) private layer: AnimationLayer) {}

  newScenarioElement(scenarioPath: ScenarioPath): void {
    this.animationSrc = scenarioPath.currentElement.animations[0].src;
  }

  resourcesLoaded(resourcesCache: ResourcesCache): void {
    this.animationJSON = resourcesCache.animationsBySrc.get(this.animationSrc);
    this.layer.clearAllAnimations();
  }

  getCurrentTime(): number {
    return this.layer.getAnimationCurrentTime(this.animationSrc);
  }

  getTotalTime(): number {
    return this.layer.getAnimationDuration(this.animationSrc);
  }

  loadAnimation(): void {
    this.layer.loadAnimation(this.animationSrc, this.animationJSON);
  }

  getIsPlaying(): boolean {
    return this.layer.getIsAnimationPlaying(this.animationSrc);
  }

  play(): void {
    this.isPlaying = true;
    this.layer.playAnimation(this.animationSrc);
  }

  pause(): void {
    this.isPlaying = false;
    this.layer.pauseAnimation(this.animationSrc);
  }

  moveTo(time: number): void {
    const timeMillis = time * 1000;
    this.layer.moveTo(this.animationSrc, timeMillis, this.isPlaying);
  }

  registerObserver(observer: AnimationLayerObserver): void {
    this.layer.registerObserver(observer);
  }
}
